// Helpers for immutable.js
import { Set as imSet } from 'immutable';


export function keyIn(...keys) {
  // Use with Map.filter(keyIn(<keys>)) -- similar to _.pick()
  const keySet = imSet(keys);
  return (v, k) => keySet.includes(k);
}
